import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'modules.OrderConfirmation.heading',
    defaultMessage: 'Order completed'
  },
  receipt: {
    id: 'receipt',
    defaultMessage: 'Receipt'
  },
  giftCardDescription: {
    id: 'modules.OrderConfirmation.giftCard.description',
    defaultMessage:
      '{quantity, plural, one {Your gift card is sent to} other {Your gift cards are sent to}} {mail} We have also sent this receipt to the same email'
  },
  giftCardListHeading: {
    id: 'modules.OrderConfirmation.giftCardList.heading',
    defaultMessage: '{quantity, plural, one {Gift card} other {Gift cards}}'
  },
  thanksForPurchase: {
    id: 'modules.OrderConfirmation.thanksForPurchase',
    defaultMessage:
      'Thank you for your purchase, this invoice will also be sent by email.'
  },
  transactionNumberNotFound: {
    id: 'could_not_load_payment_transaction',
    defaultMessage: 'Could not load payment transaction'
  },
  transactionNumber: {
    id: 'transaction_number_str',
    defaultMessage: 'Transaction number: {transactionNumber}'
  },
  date: {
    id: 'date_completed_at',
    defaultMessage: 'Date: {completedAt}'
  },
  creditCardMasked: {
    id: 'card_creditCardMasked',
    defaultMessage: 'Card: {creditCardMasked}'
  },
  giftCardLink: {
    id: 'modules.OrderConfirmation.giftCardLink',
    defaultMessage: 'See the gift card'
  }
});

export default messages;
